import { get } from "lodash";

const getHistory = state => get(state, "payment.history");

export default getHistory;
